export function genId() {
  return crypto.randomUUID();
}

export function fmtDate(ts) {
  return new Date(ts).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function fmtDur(s) {
  return `${Math.floor(s / 60)}:${(s % 60).toString().padStart(2, "0")}`;
}

export function todayKey() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function dateKey(date) {
  if (date == null) return null;
  const d = new Date(date);
  if (isNaN(d.getTime())) return null;
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function weekVol(workouts) {
  const wkStart = new Date();
  wkStart.setDate(wkStart.getDate() - wkStart.getDay());
  wkStart.setHours(0, 0, 0, 0);
  return workouts
    .filter((w) => w.startTime >= wkStart.getTime())
    .reduce(
      (a, w) =>
        a +
        (w.exerciseBlocks || []).reduce(
          (b, bl) =>
            b +
            (bl.sets || [])
              .filter((s) => s.done)
              .reduce(
                (c, s) =>
                  c + (parseFloat(s.weight) || 0) * (parseFloat(s.reps) || 0),
                0
              ),
          0
        ),
      0
    );
}

// A streak day requires meaningful completion:
//   - a workout or run logged, OR
//   - at least 3 distinct meals logged (not just a single snack)
//
// STREAK SHIELD: one missed day per rolling week doesn't break the streak
// (it just doesn't count). A single off Tuesday shouldn't nuke a 40-day
// streak — that's how streaks stay motivating instead of punishing.
export function calcStreak(workouts, runs, mealLog) {
  let s = 0;
  let daysSinceShield = 99; // eligible immediately
  const d = new Date();
  for (let i = 0; i < 60; i++) {
    const k = dateKey(d);
    const trained =
      workouts.some((w) => dateKey(w.startTime) === k) ||
      (runs || []).some((r) => dateKey(r.timestamp) === k);
    const mealCount = (mealLog[k] || []).filter(
      (m) => m.mealId !== "__water__"
    ).length;
    if (trained || mealCount >= 3) {
      s++;
      daysSinceShield++;
      d.setDate(d.getDate() - 1);
    } else if (i === 0) {
      // today doesn't count yet — check yesterday before breaking
      d.setDate(d.getDate() - 1);
    } else if (daysSinceShield >= 7) {
      // shield absorbs this gap day (doesn't count, doesn't break)
      daysSinceShield = 0;
      d.setDate(d.getDate() - 1);
    } else {
      break;
    }
  }
  return s;
}
